module.exports = __webpack_public_path__ + "img/bg.801da103.jpg";